import React, { useState, useEffect } from "react";
import Link from "next/link";
import Crumbs from "@/components/navigation/Crumbs";
import FeaturedTitleCustom from "./FeaturedTitleCustom";
import RelatedContent from "@/components/movies/RelatedContent";
import Button from "@/components/actions/Button";
import { ArrowRightIcon } from "@heroicons/react/outline";
import Testimonials from "./Testimonials";
import Editions from "./Editions";
import * as Text from "@/components/text";
import { motion } from "framer-motion";
import { localeTexts } from "@/utils/locale";
import { useRouter } from "next/router";

export default function GiraDocumental({ giraData, locale }) {
  console.log("GiraDocumental locale:", locale);
  const [color, setColor] = useState(0);

  return (
    <div className="flex flex-col items-center justify-center">
      <motion.div className="amb-container">
        <div className="flex flex-row gap-2 py-4">
          <Crumbs breadcrumbs={[{ href: "/", text: localeTexts[locale].breadcrumbs.initiatives }]} />
          <span className=" text-neutral-600">{localeTexts[locale].GiraDocumentales.breadcrumbs}</span>
        </div>
        <div className="mb-8 mt-7 flex flex-col items-center justify-center text-center md:mt-10 md:px-28 lg:mt-14 lg:px-32">
          <div className="w-full text-center font-bold text-gira">
            <Text.Title className="text-[22px] md:text-2xl md:font-semibold lg:text-2xl">
              {giraData?.headertitle?.h1}
            </Text.Title>
          </div>
          <div className="w-full px-4 py-2 text-center text-4xl font-bold leading-9 md:mb-4 md:mt-4 md:px-24 md:text-[30px] lg:px-32 lg:text-4xl">
            <h2>{giraData?.headertitle?.h2}</h2>
          </div>
          <div className="text-center font-light tracking-[-0.8px] text-neutral-800 md:w-[690px] md:px-28 md:text-2xl md:leading-[28px] lg:px-0 lg:text-[40px] lg:leading-[42px]">
            <span>{giraData?.headertitle?.description}</span>
          </div>
          {giraData?.headertitle?.large_description ? (
            <div
              className={`w-full max-w-[950px]  rounded-md bg-[#fdf2f2] p-4 text-center text-sm font-light leading-7 lg:mt-4 lg:text-[18px] lg:leading-[22px]`}
            >
              {giraData?.headertitle?.large_description}
            </div>
          ) : null}
          <div className="sm:mt-8 sm:h-[600px] sm:w-[360px] md:h-[496px] md:w-[744px] lg:mt-10 lg:h-[756px] lg:w-[1440px]">
            <video
              autoPlay
              muted
              loop
              id="myVideo"
              poster="/next_assets/img/brand-assets/hero_bg.jpg"
              className="top-0 h-full w-full object-cover"
            >
              <source
                src="https://cdn.ambulante.org/assets/AMB_CINESPOT_WEB.webm"
                type="video/webm"
              />
            </video>
          </div>
        </div>
        <Editions editions={giraData?.edicion} locale={locale} />
        <div className="flex w-full font-light tracking-[-0.8px] sm:justify-center sm:px-4 sm:pb-4 sm:text-center sm:text-[24px] sm:leading-[28px] md:pb-8 md:text-[32px] lg:justify-start lg:px-0 lg:text-left lg:text-[40px] lg:leading-[42px]">
          <span>{localeTexts[locale].GiraDocumentales.historico}</span>
        </div>
        <div className="grid w-full justify-center gap-4">
          <div className="w-full  gap-4 sm:max-w-[328px] md:max-w-[680px] lg:grid lg:max-w-[1208px] lg:grid-cols-3">
            <div className="relative col-span-2 mb-5 w-full space-y-11 md:mb-0 md:max-h-full md:max-w-[680px] lg:mx-auto lg:max-w-[795px]">
              {giraData?.peliculas?.data[0] && (
                <FeaturedTitleCustom
                  active={true}
                  setColor={setColor}
                  film_name={giraData.peliculas.data[0].attributes.film_name}
                  slug={giraData.peliculas.data[0].attributes.filmSlug}
                  original_title={
                    giraData.peliculas.data[0].attributes.film_original_title
                  }
                  directors={giraData.peliculas.data[0].attributes.Directores}
                  film_length={
                    giraData.peliculas.data[0].attributes.film_length
                  }
                  countries={giraData.peliculas.data[0].attributes.countries}
                  film_cover={
                    giraData.peliculas.data[0].attributes.film_cover_image
                  }
                  initiatives={
                    giraData.peliculas.data[0].attributes.iniciativas
                  }
                  film_year={giraData.peliculas.data[0].attributes.film_year}
                />
              )}
            </div>
            <div className="w-full gap-4 sm:grid md:flex md:w-[680px] lg:col-span-1 lg:grid lg:w-full">
              <div className="relative w-full space-y-11 sm:h-[172px] md:h-[200px] md:w-[332px] lg:h-[260px] lg:w-[397px] xl:mx-auto">
                {giraData?.peliculas?.data[1] && (
                  <FeaturedTitleCustom
                    active={true}
                    setColor={setColor}
                    film_name={giraData.peliculas.data[1].attributes.film_name}
                    slug={giraData.peliculas.data[1].attributes.filmSlug}
                    original_title={
                      giraData.peliculas.data[1].attributes.film_original_title
                    }
                    directors={giraData.peliculas.data[1].attributes.Directores}
                    film_length={
                      giraData.peliculas.data[1].attributes.film_length
                    }
                    countries={giraData.peliculas.data[1].attributes.countries}
                    film_cover={
                      giraData.peliculas.data[1].attributes.film_cover_image
                    }
                    initiatives={
                      giraData.peliculas.data[1].attributes.iniciativas
                    }
                    film_year={giraData.peliculas.data[1].attributes.film_year}
                  />
                )}
              </div>
              <div className="relative w-full space-y-11 md:h-[200px] md:w-[332px] lg:h-[260px] lg:w-[397px] xl:mx-auto">
                {giraData?.peliculas?.data[2] && (
                  <FeaturedTitleCustom
                    active={true}
                    setColor={setColor}
                    film_name={giraData.peliculas.data[2].attributes.film_name}
                    slug={giraData.peliculas.data[2].attributes.filmSlug}
                    original_title={
                      giraData.peliculas.data[2].attributes.film_original_title
                    }
                    directors={giraData.peliculas.data[2].attributes.Directores}
                    film_length={
                      giraData.peliculas.data[2].attributes.film_length
                    }
                    countries={giraData.peliculas.data[2].attributes.countries}
                    film_cover={
                      giraData.peliculas.data[2].attributes.film_cover_image
                    }
                    initiatives={
                      giraData.peliculas.data[2].attributes.iniciativas
                    }
                    film_year={giraData.peliculas.data[2].attributes.film_year}
                  />
                )}
              </div>
            </div>
          </div>

          <div className="h-full w-full gap-4 md:w-[680px] md:grid-cols-2 lg:grid lg:w-[1213px] lg:grid-cols-4">
            <div className="relative w-full space-y-11 xl:mx-auto xl:max-w-[795px]">
              {giraData?.peliculas?.data[3] && (
                <FeaturedTitleCustom
                  active={true}
                  setColor={setColor}
                  film_name={giraData.peliculas.data[3].attributes.film_name}
                  slug={giraData.peliculas.data[3].attributes.filmSlug}
                  original_title={
                    giraData.peliculas.data[3].attributes.film_original_title
                  }
                  directors={giraData.peliculas.data[3].attributes.Directores}
                  film_length={
                    giraData.peliculas.data[3].attributes.film_length
                  }
                  countries={giraData.peliculas.data[3].attributes.countries}
                  film_cover={
                    giraData.peliculas.data[3].attributes.film_cover_image
                  }
                  initiatives={
                    giraData.peliculas.data[3].attributes.iniciativas
                  }
                  film_year={giraData.peliculas.data[3].attributes.film_year}
                />
              )}
            </div>
            <div className="relative w-full space-y-11 xl:mx-auto xl:max-w-[795px]">
              {giraData?.peliculas?.data[4] && (
                <FeaturedTitleCustom
                  active={true}
                  setColor={setColor}
                  film_name={giraData.peliculas.data[4].attributes.film_name}
                  slug={giraData.peliculas.data[4].attributes.filmSlug}
                  original_title={
                    giraData.peliculas.data[4].attributes.film_original_title
                  }
                  directors={giraData.peliculas.data[4].attributes.Directores}
                  film_length={
                    giraData.peliculas.data[4].attributes.film_length
                  }
                  countries={giraData.peliculas.data[4].attributes.countries}
                  film_cover={
                    giraData.peliculas.data[4].attributes.film_cover_image
                  }
                  initiatives={
                    giraData.peliculas.data[4].attributes.iniciativas
                  }
                  film_year={giraData.peliculas.data[4].attributes.film_year}
                />
              )}
            </div>
            <div className="relative w-full space-y-11 xl:mx-auto xl:max-w-[795px]">
              {giraData?.peliculas?.data[5] && (
                <FeaturedTitleCustom
                  active={true}
                  setColor={setColor}
                  film_name={giraData.peliculas.data[5].attributes.film_name}
                  slug={giraData.peliculas.data[5].attributes.filmSlug}
                  original_title={
                    giraData.peliculas.data[5].attributes.film_original_title
                  }
                  directors={giraData.peliculas.data[5].attributes.Directores}
                  film_length={
                    giraData.peliculas.data[5].attributes.film_length
                  }
                  countries={giraData.peliculas.data[5].attributes.countries}
                  film_cover={
                    giraData.peliculas.data[5].attributes.film_cover_image
                  }
                  initiatives={
                    giraData.peliculas.data[5].attributes.iniciativas
                  }
                  film_year={giraData.peliculas.data[5].attributes.film_year}
                />
              )}
            </div>
            <div className="relative w-full space-y-11 xl:mx-auto xl:max-w-[795px]">
              {giraData?.peliculas?.data[6] && (
                <FeaturedTitleCustom
                  active={true}
                  setColor={setColor}
                  film_name={giraData.peliculas.data[6].attributes.film_name}
                  slug={giraData.peliculas.data[6].attributes.filmSlug}
                  original_title={
                    giraData.peliculas.data[6].attributes.film_original_title
                  }
                  directors={giraData.peliculas.data[6].attributes.Directores}
                  film_length={
                    giraData.peliculas.data[6].attributes.film_length
                  }
                  countries={giraData.peliculas.data[6].attributes.countries}
                  film_cover={
                    giraData.peliculas.data[6].attributes.film_cover_image
                  }
                  initiatives={
                    giraData.peliculas.data[6].attributes.iniciativas
                  }
                  film_year={giraData.peliculas.data[6].attributes.film_year}
                />
              )}
            </div>
          </div>
          <div className="flex w-full justify-center">
            <Link href="/catalogo/" passHref>
              <Button
                type="submit"
                color="secondary-light"
                size="lg"
                className="sm:mb-8 sm:w-[328px] md:w-fit lg:mb-20 lg:mt-8"
                trailingIcon={<ArrowRightIcon />}
                label={localeTexts[locale].GiraDocumentales.buttonCatalogo}
              ></Button>
            </Link>
          </div>
        </div>
      </motion.div>
      <Testimonials
        title={localeTexts[locale].GiraDocumentales.testimonials.title}
        subtitle={localeTexts[locale].GiraDocumentales.testimonials.subtitle}
        quotes={giraData?.quotes}
      />
      <motion.div className="amb-container">
        <div className="my-5">
          <RelatedContent
            movieId={giraData?.peliculas?.data[2]?.id}
            showMovie={false}
            showEvents={false}
          />
        </div>
      </motion.div>
    </div>
  );
}